var Eventable = require('Eventable');
var each = require('./../../lib/util').each;
var strToNumCompare = require('./../../lib/util').strToNumCompare;
var utils = require('./../global/utils');
var gdic = require('./../global/globalDic');
var isEmpty = utils.isEmpty;
var isObjectValueEqual = utils.isObjectValueEqual;
var jsonHandler = utils.jsonHandler;

// 获取session/group在父节点中的位置
var getPosition = function (sessions, session) {
  var position = -1;
  for (var index = 0, length = sessions.length; index < length; index++) {
    var item = sessions[index];
    if (session.contact && item.contact) {
      if (session.contact.user_id == item.contact.user_id && session.contact.user_source == item.contact.user_source) {
        position = index;
        break;
      }
    }
    if (session.group && item.group && session.group.id == item.group.id) {
      position = index;
      break;
    }
  }
  return position;
};

// 排序
var compare = function (a, b) {
  if (a.sort_time > b.sort_time)
    return -1;
  else if (a.sort_time < b.sort_time)
    return 1;
  else
    return 0;


  /*if (a.msg && b.msg) {
   return a.msg.send_time < b.msg.send_time ? 1 : -1;
   }

   if (!a.msg && !b.msg) {
   if (a.contact && b.contact) {
   return a.contact.name_spell < b.contact.name_spell ? -1 : 1;
   }

   if (a.group && !b.group) {
   return -1;
   }
   if (!a.group && b.group) {
   return 1;
   }

   return 0;
   }

   if (!a.msg && b.msg) {
   return -1;
   }

   if (a.msg && !b.msg) {
   return 1;
   }

   return 0;*/
};

var sequence = function (sessions) {
  var list = [];
  each(sessions, function (index, session) {
    if (session.group) {
      list.push('group-' + session.group.id);
    }
    else if (session.contact) {
      if (session.contact.shop_id && session.contact.shop_source) {
        list.push('contact-' + session.contact.user_id + '@' + session.contact.user_source + '@@' + session.contact.shop_id + '@' + session.contact.shop_source);
      } else {
        list.push('contact-' + session.contact.user_id + '@' + session.contact.user_source);
      }
    }
  });
  return list;
};

// 置顶用户和非置顶用户分离
var sortSessions = function (sessions) {
  var topSessions = [];
  var sesTopSessions = [];
  var normalSessions = [];
  each(sessions, function (index, session) {
    if (session.is_top_group) {
      topSessions.push(session);
    } else if (session.contact && session.contact.msg_set && session.contact.msg_set.ses_top == 1 && isEmpty(session.contact.shop_id)) {
      sesTopSessions.push(session);
    } else {
      normalSessions.push(session);
    }
  });
  topSessions.sort(compare);
  sesTopSessions.sort(compare);
  normalSessions.sort(compare);
  return topSessions.concat(sesTopSessions).concat(normalSessions);
};

// 排序、对比更新
var sort = function (sessions) {
  var before = sequence(sessions);
  //sessions.sort(compare);
  sessions = sortSessions(sessions);
  var after = sequence(sessions);
  return before.join(',') != after.join(',');
};

// 排序、对比更新, 返回排序后的新数组
var sortNew = function (sessions) {
  var before = sequence(sessions);
  //sessions.sort(compare);
  sessions = sortSessions(sessions);
  var after = sequence(sessions);
  return {
    result: before.join(',') != after.join(','),
    sortedArray: sessions
  }
};

var isMsgSame = function (a, b) {
  if (!a && !b)
    return true;

  if (a && !b)
    return false;

  if (!a && b)
    return false;

  if (!a.msg_id && !b.msg_id)
    return true;

  var isMsgIdSame = strToNumCompare(a.msg_id, b.msg_id) == 0;
  if (isMsgIdSame && !isObjectValueEqual(a, b)) {
    return false;
  }
  return isMsgIdSame;
};

var isSessionSame = function (a, b) {
  return jsonHandler.stringify(a) == jsonHandler.stringify(b);
}

// 计算子节点会话未读数量总和
var calChildrenUnread = function (node) {
  var total = 0;
  each(node.children, function (index, child) {
    if (child.unread) {
      total += child.unread;
    }
  });
  return total;
};

// 获取子节点最后一条信息
var getChildrenLastMsg = function (node) {
  var msg;

  each(node.children, function (index, child) {
    if (!child.msg)
      return;

    if (!msg) {
      msg = child.msg;
    }
    else {
      if (strToNumCompare(msg.msg_id, child.msg.msg_id) < 0) {
        msg = child.msg;
      }
    }
  });

  return msg;
};

var build_key_ids = function (session) {
  function build(session) {
    if (session.children) {
      session.group_key_ids = {};
      session.key_ids = {};
      each(session.children, function (index, item) {
        var group = item.group;
        if (group && group.id) {
          session.group_key_ids[group.id] = index;
        }
        var contact = item.contact;
        if (contact) {
          if (contact.is_shop_mode && contact.shop_id && contact.shop_source) {
            session.key_ids[contact.user_id + '@' + contact.user_source + '@@' + contact.shop_id + '@' + contact.shop_source] = index;
          } else {
            session.key_ids[contact.user_id + '@' + contact.user_source] = index;
          }
        }
        if (item.children) {
          build(item);
        }
      });
    }
  }
  build(session);
}

var need_pre_key_ids = true;

var Session = function () {
  Eventable.call(this);

  this._totalunread = 0;
  this._root = {
    is_root: true,     // root节点
    contact: null,     // contact 和 group 同时只能有一个
    group: null,       // contact 和 group 同时只能有一个
    children: [],
    unread: 0,         // 未读消息数量
    msg: null,         // 最后一条消息
    checked: false     // 是否选中
  };
};
Session.prototype = Object.create(Eventable.prototype);

// 通过group_id 或者 user_id,user_source查找相应的session
Session.prototype.getSession = function () {
  var contactKey;
  var find_in_key;
  var group_id;
  if (arguments.length == 1) {
    group_id = arguments[0];
  }
  else if (arguments.length == 2) {
    var user_id = arguments[0];
    var user_source = arguments[1];
    contactKey = user_id + '@' + user_source;
  } else if (arguments.length == 3) {
    var user_id = arguments[0];
    var user_source = arguments[1];
    var userInfo = arguments[2];
    contactKey = user_id + '@' + user_source;
    if (userInfo && userInfo.shop_id && userInfo.shop_source) {
      contactKey += '@@' + userInfo.shop_id + '@' + userInfo.shop_source;
    }
  } else if (arguments.length == 4) {
    var user_id = arguments[0];
    var user_source = arguments[1];
    var userInfo = arguments[2];
    find_in_key = arguments[3];
    contactKey = user_id + '@' + user_source;
    if (userInfo && userInfo.is_shop_mode && userInfo.shop_id && userInfo.shop_source) {
      contactKey += '@@' + userInfo.shop_id + '@' + userInfo.shop_source;
    }
  }

  return (function find(session) {
    var result = null;

    if (group_id != undefined) {
      var group = session.group;
      if (group && group.id == group_id)
        result = session;
    }

    if (user_id != undefined && user_source != undefined) {
      var contact = session.contact;
      if (contact && contact.user_id == user_id && contact.user_source == user_source) {
        if (isEmpty(userInfo) && !contact.is_shop_mode) {
          result = session;
        } else {
          if (!isEmpty(userInfo) && (userInfo.shop_id == contact.shop_id && userInfo.shop_source == contact.shop_source)) {
            result = session;
          }
        }
      }
    }

    if (result)
      return result;

    if (session.children) {
      if (find_in_key) {
        if (group_id && !isEmpty(session.group_key_ids)) {
          var _index = session.group_key_ids[group_id];
          if (!isNaN(_index)) {
            result = session.children[_index];
          } 
        }
        if (!isEmpty(session.key_ids) && contactKey) {
          var _index = session.key_ids[contactKey];
          if (!isNaN(_index)) {
            result = session.children[_index];
          } 
        }
      }
      if (!result) {
        each(session.children, function (index, item) {
          result = find(item);
          if (result)
            return false;
        });
      }
    }
    return result;
  })(this._root);
};

// 通过group_id 或者 user_id,user_source查找相应的父session
Session.prototype.getParentSession = function () {
  if (arguments.length == 1) {
    var group_id = arguments[0];
  }
  else if (arguments.length == 2) {
    var user_id = arguments[0];
    var user_source = arguments[1];
  }

  return (function find(session) {
    var parent = null;
    for (var index = 0, length = session.children.length; index < length; index++) {
      var child = session.children[index];

      if (child.group) {
        if (child.group.id == group_id) {
          parent = session;
          break;
        }

        parent = find(child);
        if (parent)
          break;
      }

      if (user_id != undefined && user_source != undefined && child.contact) {
        var contact = child.contact;
        if (contact && contact.user_id == user_id && contact.user_source == user_source) {
          parent = session;
          break;
        }
      }
    }
    return parent;
  })(this._root);
};

// 增加新的组节点，msg:null
Session.prototype.addGroup = function (group) {
  var session = this.getSession(group.id);
  if (session)
    return;

  this._root.children.unshift({
    group: group,
    children: [],
    unread: 0,
    msg: null,
    unread_show_type: group.unread_show_type || '',
    is_top_group: !group.is_anonymous_group,
    sort_time: (new Date()).getTime()
  });
  // this._root.children.sort(compare);
  this.triggerEvent('childrenchanged', this._root);
};

// 增加新的联系人,msg: null
Session.prototype.addContact = function (contact) {
  var session = this.getSession(contact.user_id, contact.user_source, contact);
  if (session)
    return;
  var initTime = (new Date()).getTime();
  this._root.children.unshift({
    contact: contact,
    unread: 0,
    msg: null,
    sort_time: initTime
  });
  //this._root.children.sort(compare);
  this.triggerEvent('childrenchanged', this._root);
};

// 更新会话，包括未读和信息,contactsession：一个会话
Session.prototype.addContactSession = function (contactsession) {
  var contact = contactsession.user;
  if (!contact) {
    return;
  }
  var currentContact = contactsession.currentContact;
  var msg = contactsession.msg;
  var session = this.getSession(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source);
  if (session)
    return;
  var initTime = contactsession.sort_time ? contactsession.sort_time : (new Date()).getTime();
  var unread = contactsession.unread ? contactsession.unread : 0;
  var tmpMsg = contact.shop_id ? gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source + '@@' + contact.shop_id + '@' + contact.shop_source) : gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source);
  this._root.children.unshift({
    contact: contact,
    unread: unread,
    msg: msg,
    falseMsg: tmpMsg,
    sort_time: initTime,
    unread_show_type: contactsession.unread_show_type,
    is_top_group: !!contactsession.is_top_group
  });
  if (!isEmpty(currentContact)) {
    var contactKey = currentContact.user_id + '@' + currentContact.user_source;
    if (!isEmpty(currentContact.shop_id) && !isEmpty(currentContact.shop_source)) {
      contactKey += '@@' + currentContact.shop_id + '@' + currentContact.shop_source;
    }
    var sessionKey = contact.user_id + '@' + contact.user_source;
    if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
      sessionKey += '@@' + contact.shop_id + '@' + contact.shop_source;
    }
    if (contactKey === sessionKey) {
      this._root.children[0].checked = true;
    }
  }
  var sortedChildren = sortNew(this._root.children);
  if (sortedChildren.result) {
    this._root.children = sortedChildren.sortedArray
  }
  this.triggerEvent('childrenchanged', this._root);
  this.calTotalUnread();
};

// 增加多个会话,contactsessions：会话列表
Session.prototype.addContactSessions = function (contactsessions) {
  var changed = false;
  var lastsession = null;
  var temprootchild = [];
  if (need_pre_key_ids) {
    build_key_ids(this._root);
  }
  for (var index = 0, length = contactsessions.length; index < length; index++) {
    var contactsession = contactsessions[index];
    var contact = contactsession.user;
    var msg = contactsession.msg;
    var unread = contactsession.unread ? contactsession.unread : 0;
    var session = this.getSession(contact.user_id, contact.user_source, contact, need_pre_key_ids);
    var tmpMsg = contact.shop_id ? gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source + '@@' + contact.shop_id + '@' + contact.shop_source) : gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source);
    if (session) {
      let jumped = false;
      if (session.msg && session.msg.msg_id < 0 && session.msg.is_mine && session.msg.status === "FAIL" && strToNumCompare(contactsession.sort_time, session.msg.sort_time) < 0) {
        jumped = true;
      }
      if (jumped) {
        contactsession.msg = session.msg;
      }
      if (!isEmpty(session.msg) && !isEmpty(tmpMsg) && strToNumCompare(tmpMsg.msg_id, session.msg.msg_id) > 0) {
        contactsession.sort_time = tmpMsg.send_time;
      }
      if (session.sort_time != contactsession.sort_time && !session.is_top_group) {
        session.sort_time = contactsession.sort_time;
        changed = true;
      }
      if (contact.update_time && contact.update_time != session.contact.update_time) {
        changed = true;
      }
      if (contact.msg_set && session.contact.msg_set && (contact.msg_set.ses_top != session.contact.msg_set.ses_top || contact.msg_set.silent != session.contact.msg_set.silent)) {
        changed = true;
      }
      // session（已有）,contactsession（更新）
      if (changed || !isMsgSame(session.msg, contactsession.msg) || !isSessionSame(session.contact, contact) || session.unread != contactsession.unread) {
        session.falseMsg = tmpMsg;
        session.msg = contactsession.msg;
        session.unread = unread;
        session.contact = contact;
        session.unread_show_type = contactsession.unread_show_type;
        session.is_top_group = contactsession.is_top_group;
        this.triggerEvent('selfchanged', session);
        changed = true;
        if (unread > 0) {
          if (!lastsession) {
            lastsession = contactsession;
          }
          else {
            if (!!contactsession.msg && contactsession.msg.send_time > lastsession.msg.send_time) {
              lastsession = contactsession;
            }
          }
        }
      }
      // 保持sdk传出的session的列表顺序不变
      temprootchild[index] = session;
    }
    else {
      session = {
        contact: contact,
        unread: unread,
        msg: msg,
        falseMsg: tmpMsg,
        sort_time: contactsession.sort_time,
        unread_show_type: contactsession.unread_show_type,
        is_top_group: !!contactsession.is_top_group
      };
      temprootchild.push(session);
      changed = true;
    }
  }

  if (contactsessions.length < this._root.children.length) {
    changed = true;
  }

  if (!changed)
    return;

  // 按照sdk层传出来的会话排序进行展示，不再进行排序
  // this._root.children.sort(compare);
  // 保留组的子元素，其他取temprootchild
  var groupChilds = [];
  each(this._root.children, function (index, child) {
    if (child.group && child.group.id && child.children && child.children.length) {
      groupChilds.push(child);
    }
  });
  groupChilds.sort(compare);
  this._root.children = sortSessions(groupChilds.concat(temprootchild));

  this.triggerEvent('childrenchanged', this._root);
  var totalunread = this.calTotalUnread();
  if (totalunread != this._totalunread) {
    this._totalunread = totalunread;
    this.triggerEvent('totalUnreadChanged', {
      lastsession: !lastsession ? null : !lastsession.user ? null : lastsession.user,
      amount: totalunread
    });
  }
};

// 将会话添加到组里
Session.prototype.setContactToGroup = function () {
  let _user_id;
  let _user_source;
  let _group_id;
  let _params;
  let _userArray;
  let _clear = false;
  if (arguments.length == 1) {
    return;
  }
  else if (arguments.length == 2) {
    _params = arguments[0];
    if (!isEmpty(_params)) {
      _userArray = _params.sessions;
      _clear = _params.clear;
    }
    if (!(!isEmpty(_userArray) && _userArray.length >= 1)) {
      return;
    }
    _group_id = arguments[1];
  } else if (arguments.length == 3) {
    _user_id = arguments[0];
    _user_source = arguments[1];
    _group_id = arguments[2];
  }
  const handleTransform = (user_id, user_source, group_id) => {
    let contact_session = this.getSession(user_id, user_source);
    let to_group_session = this.getSession(group_id);
    if (!contact_session || !to_group_session)
      return null;

    let from_parent_session = this.getParentSession(user_id, user_source);
    let position = getPosition(from_parent_session.children, contact_session);
    from_parent_session.children.splice(position, 1);
    // 无法移除被删除的会话， mark by likd-a
    if (_clear) {
      to_group_session.children = [];
      _clear = false;
    }
    to_group_session.children.push(contact_session);
    // to_group_session.children.sort(compare);

    return {
      from_parent_session,
      to_group_session
    }
  }
  const handlePublish = (sessionPublish) => {
    if (isEmpty(sessionPublish)) {
      return;
    }

    sessionPublish.msg = getChildrenLastMsg(sessionPublish);
    sessionPublish.unread = calChildrenUnread(sessionPublish);
    sessionPublish.sort_time = sessionPublish.msg && sessionPublish.msg.send_time;

    this.triggerEvent('childrenchanged', sessionPublish);
    this.triggerEvent('selfchanged', sessionPublish);
  }

  if (!isEmpty(_user_id) && !isEmpty(_user_source) && !isEmpty(_group_id)) {
    let sessionWay = handleTransform(_user_id, _user_source, _group_id);
    if (!isEmpty(sessionWay)) {
      handlePublish(sessionWay.from_parent_session);
      handlePublish(sessionWay.to_group_session);
    }
  } else if (!isEmpty(_group_id) && !isEmpty(_userArray) && _userArray.length) {
    let sessionWays = [];
    let group_id_keeps = {};
    let has_root = false;
    const loadSessionWay = (_session) => {
      if (isEmpty(_session)) {
        return;
      }
      if (_session.is_root && !has_root) {
        has_root = true;
        sessionWays.push(_session);
      }
      if (_session.group && !group_id_keeps[_session.group.id]) {
        group_id_keeps[_session.group.id] = true;
        sessionWays.push(_session);
      }
    }
    for (let userKey of _userArray) {
      user_id = userKey.user_id;
      user_source = userKey.user_source;
      let _sessionWay = handleTransform(user_id, user_source, _group_id);
      if (!isEmpty(_sessionWay)) {
        loadSessionWay(_sessionWay.from_parent_session);
        loadSessionWay(_sessionWay.to_group_session);
      }
    }
    for (let sessionWay of sessionWays) {
      handlePublish(sessionWay);
    }
  }
};

Session.prototype.addContactGroupSessions = function (contactsessions, group_id) {
  let changed = false;
  let temprootchild = [];
  let to_group_session = this.getSession(group_id);
  if (isEmpty(to_group_session)) {
    return;
  }
  for (var index = 0, length = contactsessions.length; index < length; index++) {
    var contactsession = contactsessions[index];
    var contact = contactsession.user;
    var msg = contactsession.msg;
    var unread = contactsession.unread ? contactsession.unread : 0;
    var session = this.getSession(contact.user_id, contact.user_source, contact);
    var tmpMsg = contact.shop_id ? gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source + '@@' + contact.shop_id + '@' + contact.shop_source) : gdic.get('tmpMsg-session-' + contact.user_id + '@' + contact.user_source);
    if (session) {
      if (!isEmpty(session.msg) && !isEmpty(tmpMsg) && strToNumCompare(tmpMsg.msg_id, session.msg.msg_id) > 0) {
        contactsession.sort_time = tmpMsg.send_time;
      }
      if (session.sort_time != contactsession.sort_time && !session.is_top_group) {
        session.sort_time = contactsession.sort_time;
        changed = true;
      }
      if (contact.update_time && contact.update_time != session.contact.update_time) {
        changed = true;
      }
      // session（已有）,contactsession（更新）
      if (changed || !isMsgSame(session.msg, contactsession.msg) || !isSessionSame(session.contact, contact) || session.unread != contactsession.unread) {
        session.falseMsg = tmpMsg;
        session.msg = contactsession.msg;
        session.unread = unread;
        session.contact = contact;
        session.unread_show_type = contactsession.unread_show_type;
        session.is_top_group = contactsession.is_top_group;
        this.triggerEvent('selfchanged', session);
        changed = true;
      }
      // 保持sdk传出的session的列表顺序不变
      temprootchild[index] = session;
    }
    else {
      session = {
        contact: contact,
        unread: unread,
        msg: msg,
        falseMsg: tmpMsg,
        sort_time: contactsession.sort_time,
        unread_show_type: contactsession.unread_show_type,
        is_top_group: !!contactsession.is_top_group,
        is_anonymous_user: contactsession.is_anonymous_user
      };
      temprootchild.push(session);
      changed = true;
    }
  }

  if (to_group_session.children && contactsessions.length < to_group_session.children.length) {
    changed = true;
  }

  to_group_session.children = sortSessions(temprootchild);
  to_group_session.msg = getChildrenLastMsg(to_group_session);
  to_group_session.unread = calChildrenUnread(to_group_session);
  to_group_session.sort_time = to_group_session.msg && to_group_session.msg.send_time;

  if (!changed)
    return;

  let lastsession = null;
  each(this._root.children, function (index, child) {
    let unread = child.unread ? child.unread : 0;
    if (unread > 0) {
      if (!lastsession) {
        lastsession = child;
      }
      else {
        if (!!child.msg && child.msg.send_time > lastsession.msg.send_time) {
          lastsession = child;
        }
      }
    }
  });

  this._root.children = sortSessions(this._root.children);

  this.triggerEvent('selfchanged', to_group_session);
  this.triggerEvent('childrenchanged', to_group_session);
  this.triggerEvent('childrenchanged', this._root);

  var totalunread = this.calTotalUnread();
  if (totalunread != this._totalunread) {
    this._totalunread = totalunread;
    this.triggerEvent('totalUnreadChanged', {
      lastsession: !lastsession ? null : !lastsession.user ? null : lastsession.user,
      amount: totalunread
    });
  }
};

// 改变最后一条消息
Session.prototype.changeLastMsg = function (user_id, user_source, msg) {
  var contact = {
    user_id: user_id,
    user_source: user_source,
    shop_id: msg.shop_id,
    shop_source: msg.shop_source
  }
  var contact_session = this.getSession(user_id, user_source, contact);
  if (!contact_session)
    return;

  contact_session.msg = msg;

  this.triggerEvent('selfchanged', contact_session);
  var parent = this.getParentSession(user_id, user_source);

  parent.msg = msg;
  this.triggerEvent('selfchanged', parent);
  if (sort(parent.children)) {
    this.triggerEvent('childrenchanged', parent);
  }
  if (parent.group) {
    var grand = this.getParentSession(parent.group.id);
    if (grand) {
      if (sort(grand.children)) {
        this.triggerEvent('selfchanged', grand);
      }
    }
  }
};

// 改变最后一条假消息
Session.prototype.changeLastFalseMsg = function () {
  var user_id, user_source, shop_id, shop_source, falseMsg;
  if (arguments.length === 5) {
    user_id = arguments[0];
    user_source = arguments[1];
    shop_id = arguments[2];
    shop_source = arguments[3];
    falseMsg = arguments[4];
  } else {
    user_id = arguments[0];
    user_source = arguments[1];
    falseMsg = arguments[2];
  }
  var contact = {
    user_id: user_id,
    user_source: user_source,
    shop_id: (falseMsg ? falseMsg.shop_id : null) || shop_id || null,
    shop_source: (falseMsg ? falseMsg.shop_source : null) || shop_id || null
  }
  var contact_session = this.getSession(user_id, user_source, contact);
  if (!contact_session)
    return;

  contact_session.falseMsg = falseMsg;
  if (!isEmpty(falseMsg) && !isEmpty(contact_session.msg) && strToNumCompare(falseMsg.msg_id, contact_session.msg.msg_id) > 0) {
    contact_session.sort_time = falseMsg.send_time;
  }
  if (isEmpty(falseMsg) && !isEmpty(contact_session.msg)) {
    contact_session.sort_time = contact_session.msg.send_time;
  }
  this.triggerEvent('selfchanged', contact_session);
  var parent = this.getParentSession(user_id, user_source);
  var sortedChildren = sortNew(parent.children);
  if (sortedChildren.result) {
    let _parent = $.extend({

    }, parent, {
      children: sortedChildren.sortedArray
    });
    this.triggerEvent('childrenchanged', _parent);
  }
  // if (parent.group) {
  //   var grand = this.getParentSession(parent.group.id);
  //   if (grand) {
  //     if (sort(grand.children)) {
  //       this.triggerEvent('selfchanged', grand);
  //     }
  //   }
  // }
};

// 计算所有未读数量
Session.prototype.calTotalUnread = function () {
  var unread = 0;

  (function cal(node) {
    if (node.contact && node.unread_show_type !== 'rash' && !node.is_anonymous_user) {
      unread += node.unread;
    }

    if (node.children) {
      for (var index = 0, length = node.children.length; index < length; index++) {
        cal(node.children[index]);
      }
    }
  })(this._root);

  return unread;
};

// 根据传入的judge条件，筛选节点
Session.prototype.search = function (judge) {
  return (function execute(node) {
    if (judge(node))
      return node;

    var result = null;
    each(node.children, function (index, item) {
      result = execute(item);
      if (result) {
        return false;
      }
    });
    return result;
  })(this._root);
};

// 选中某个会话
Session.prototype.setChecked = function (user_id, user_source, userInfo) {
  // 当前选中项
  var old_session = this.search(function (node) {
    return node.checked === true;
  });
  // 新选中项
  var new_session = this.search(function (node) {
    var contact = node.contact;
    if (contact && contact.user_id == user_id && contact.user_source == user_source) {
      if (userInfo && userInfo.shop_id == contact.shop_id && userInfo.shop_source == contact.shop_source) {
        return true;
      }
      if (!userInfo) {
        return true;
      }
    }
    return false;
  });

  if (old_session == new_session)
    return;

  if (old_session) {
    old_session.checked = false;
    this.triggerEvent('selfchanged', old_session);
  }

  if (new_session) {
    new_session.checked = true;
    this.triggerEvent('selfchanged', new_session);
  }
};

//通过键盘切换session
Session.prototype.tabSession = function (keycode, currentContact) {
  var index = "";
  var parentSession = this._root;
  if (currentContact) {
    var session = this.getSession(currentContact.user_id, currentContact.user_source, currentContact);
    parentSession = this.getParentSession(currentContact.user_id, currentContact.user_source);
    index = getPosition(parentSession.children, session);
  } else {

  }
  var next;
  if (keycode === 38) {
    if (index !== 0 && !index) {
      next = parentSession.children.length - 1;
    } else if (index === 0) {
      return false;
    } else {
      next = index - 1;
    }
  } else if (keycode === 40) {
    if (index === parentSession.children.length - 1) {
      return false;
    } else if (index !== 0 && !index) {
      next = 0;
    } else {
      next = index + 1;
    }
  }
  var nextContact = parentSession.children[next].contact;
  this.triggerEvent("tabSession", nextContact);
};

// 删除所有选中的会话
Session.prototype.removeChecked = function () {
  // 当前选中项
  var old_session = this.search(function (node) {
    return node.checked === true;
  });
  if (old_session) {
    old_session.checked = false;
    this.triggerEvent('selfchanged', old_session);
  }
}
module.exports = new Session();
